// Library imports
import axios from 'axios';
import _ from 'lodash';
// Project imports
import * as types from './actionTypes';
import * as urls from './urlTypes';

import { toastError } from '../util/toastUtils';
import { RLD_SEAT_LIMIT_ERROR } from '../components/RldTool/RldConstant';

// Thunks - actions that return a function that accepts a dispatch

const encodeObjToQueryParam = obj => {
  const sq = _.cloneDeep(obj);
  Object.keys(sq).map(k => {
    if (!sq[k] || _.isEmpty(sq[k])) {
      delete sq[k];
    }
    return false;
  });
  return Object.entries(sq)
    .map(e => e.join('='))
    .join('&');
};

export const clearUserSearch = () => dispatch => {
  dispatch({
    type: types.CLEAR_ADMIN_USERS_SEARCH,
    data: {
      data: {},
      query: {},
    },
  });
};

export const clearAccountSearch = () => dispatch => {
  dispatch({
    type: types.CLEAR_ADMIN_ACCOUNTS_SEARCH,
  });
};
export const clearAdminAccountSearch = () => dispatch => {
  dispatch({
    type: types.CLEAR_ADMIN_ACCOUNTS_SEARCH_DATA,
  });
};

export const clearAllSearch = () => dispatch => {
  dispatch(clearUserSearch());
  dispatch(clearAccountSearch());
  dispatch(clearAdminAccountSearch());
};

export const getAdminUserData = async param => {
  const sq = encodeObjToQueryParam(param);
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/users`;
  if (sq) {
    url = `${urls.API_GATEWAY_URL}/api/admin-service/users?${sq}`;
  }
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      const userData = response.data.data.map(user => {
        const listOfAccounts = user.accounts;
        const accounts = listOfAccounts
          .map(item =>
            item.accountType === 'TPP'
              ? item.accountName + ' ' + '(Third Party)'
              : item.accountName
          )
          .join(' , ');
        const data = {
          ...user,
          accountNames: accounts,
        };
        return data;
      });
      return {
        ...response.data,
        data: userData,
      };
    }
    return false;
  } catch (error) {
    toastError('Api failed to get users list');
    return false;
  }
};

export const isUserSearching = () => async dispatch => {
  dispatch({
    type: types.ADMIN_USER_SEARCHING,
  });
};

export const getAdminUserList = param => async dispatch => {
  const sq = encodeObjToQueryParam(param);
  if (sq === 'pageNo=1') {
    dispatch(clearUserSearch());
  } else {
    dispatch({
      type: types.ADMIN_USERS,
      data: {
        adminUsers: {},
        query: param,
        isUserSearching: false,
      },
    });
    const adminUserData = await getAdminUserData(param);
    if (adminUserData) {
      dispatch({
        type: types.ADMIN_USERS,
        data: {
          data: adminUserData,
          isUserSearching: true,
          query: param,
        },
      });
    }
  }
};

export const getAdminAccountsData = async param => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/accounts`;
  const sq = encodeObjToQueryParam(param);
  if (sq) {
    url = `${urls.API_GATEWAY_URL}/api/admin-service/accounts?${sq}`;
  }
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return {
        ...response.data,
        data: response.data.data,
      };
    }
    return false;
  } catch (error) {
    toastError('Api failed to get accounts list');
    return false;
  }
};

export const createUser = async (data, userId) => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/user`;
  let method = 'post';
  if (userId) {
    method = 'put';
    url = `${urls.API_GATEWAY_URL}/api/admin-service/user/${userId}`;
  }
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
      data,
    });
    return response;
  } catch (error) {
    if (error.response.data.status === 422) {
      return {
        error: error.response.data.message,
      };
    } else if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to create user');
    return false;
  }
};

export const getAdminAccountList = param => async dispatch => {
  const adminAccountData = await getAdminAccountsData(param);
  const filteredAccounts = adminAccountData.data.filter(
    item => !item.accountName.includes('retired')
  );
  if (adminAccountData) {
    dispatch({
      type: types.ADMIN_ACCOUNTS,
      data: {
        data: {
          totalPages: adminAccountData.totalPages,
          currentPage: adminAccountData.currentPage,
          hasMorePages: adminAccountData.hasMorePages,
          data: filteredAccounts,
        },
        query: param,
      },
    });
  }
};

export const searchAccounts = param => async dispatch => {
  dispatch({
    type: types.ADMIN_ACCOUNTS_SEARCH_DATA,
    data: {
      data: {},
      query: param,
      isSearching: false,
    },
  });
  const adminAccountData = await getAdminAccountsData(param);
  const filteredAccounts = adminAccountData.data.filter(
    item => !item.accountName.includes('retired')
  );
  if (adminAccountData) {
    dispatch({
      type: types.ADMIN_ACCOUNTS_SEARCH_DATA,
      data: {
        data: {
          totalPages: adminAccountData.totalPages,
          currentPage: adminAccountData.currentPage,
          hasMorePages: adminAccountData.hasMorePages,
          data: filteredAccounts,
        },
        query: param,
        isSearching: true,
      },
    });
  }
  // }
};

export const getUserDetail = async userId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/user/${userId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get user details');
    return false;
  }
};

export const changeStatus = async (userId, status) => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/user/${userId}/status/${status}`;
  try {
    const response = await axios({
      url,
      method: 'put',
      withCredentials: true,
      data: {},
    });

    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to change user stauts');
    return false;
  }
};

export const resetPassword = async email => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/user/changepassword?email=${email}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      withCredentials: true,
      data: {},
    });

    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to reset password');
    return false;
  }
};

export const backToAccountManagement = () => dispatch => {
  dispatch(clearAdminAccountSearch());
  dispatch({
    type: types.TOGGLE_ACCOUNT_DETAILS,
    showAccountDetails: false,
  });
};

export const getAccountDetails = async publicId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/account/${publicId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    return {
      ...response.data,
      account: response.data.account,
    };
  } catch (error) {
    toastError('Api failed to get account account details');
    return false;
  }
};

export const fetchAccountDetails = account => async dispatch => {
  if (account.activeStatus && account.activeStatus === 'Y') {
    dispatch({
      type: types.TOGGLE_ACCOUNT_DETAILS,
      showAccountDetails: true,
    });
    const accountDetail = await getAccountDetails(account.publicId);
    if (accountDetail) {
      const {
        account,
        modules,
        roles,
        users,
        teams,
        entitlements,
      } = accountDetail;
      dispatch({
        type: types.ACCOUNT_DETAILS_SUCCESS,
        data: {
          ...account,
          features: modules,
          roles,
          users,
          teams,
          entitlements,
        },
      });
    } else {
      dispatch(backToAccountManagement());
    }
  } else {
    toastError('ERROR: Account is not active');
  }
};

export const exportUsers = async accounts => {
  const url = `${
    urls.API_GATEWAY_URL
  }/api/admin-service/users/account/${accounts.join(',')}/export`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    toastError(error.response.data.message);
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    return false;
  }
};

export const unblockUser = async userId => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/user`;
  let method = 'post';
  if (userId) {
    method = 'put';
    url = `${urls.API_GATEWAY_URL}/api/admin-service/user/${userId}/unblock`;
  }
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    toastError('Api failed to unblock user');
    return false;
  }
};
